<div
  class="content-w-98"
  *ngrxLet="sharedService.startTourObs$ as isTourOn"
  [ngClass]="{ 'disabled-popup': this.showView && !this.showEdit }"
>
  <div class="d-flex align-items-center">
    <div class="col-12">
      <label class="headerName">{{ isTourOn[0] ? 'Westin' : scenarioName }}</label>
    </div>
  </div>
  <div class="col-12">
    <label class="subTitleName">Configuration</label>
  </div>

  <div class="validation-error" *ngIf="isScenarioNameLimitExceeded">
    <span
      >Error: Scenario report name exceeds the character limit. Please use 15 characters or
      fewer.</span
    >
  </div>

  <div
    [ngClass]="{ 'disabled-project': isScreenDisabled }"
    class="setPaddidngMainContainer px-0"
    *ngrxLet="projectFacade.orgReportingError$ as orgErr"
  >
    <form [formGroup]="scenarioConfigForm" (keydown.enter)="$event.preventDefault()">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="scenarioName"
              [control]="scenarioConfigForm.get('scenarioName')"
              label="Scenario name"
              [name]="'scenarioName'"
              placeholder="Scenario name"
              [maxLength]="50"
              [submitted]="false"
              [disabled]="isScreenDisabled || !showEdit"
              (customBlur)="onBlur($event)"
              (inputEvent)="onInput($event)"
            >
            </piqet-angular-common-input>
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="shortScenarioName"
              [control]="scenarioConfigForm.get('shortScenarioName')"
              label="Short scenario name"
              placeholder="Short scenario name"
              [maxLength]="15"
              [name]="'shortScenarioName'"
              [submitted]="false"
              [disabled]="isScreenDisabled || !showEdit"
              (customBlur)="onBlur($event)"
              (inputEvent)="onInput($event)"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-4">
          <label
            *ngIf="scenarioConfigForm.get('status')?.value && !scenarioImg"
            class="placeholder-sub-header s-img"
            >Holder_text</label
          >

          <piqet-angular-file-upload
            #scenarioFileUpload
            type="image"
            [customConfig]="scenarioImageUploadConfig"
            [existingFileUrl]="scenarioImg"
            [existingFileName]="selectedFiles"
            [isImageValid]="isImageValid"
            (fileSelected)="onScenarioImageSelected($event)"
            (removeConfirmation)="deleteConfirmation(scenarioId)"
            customClass="col-sm-6"
          >
          </piqet-angular-file-upload>
        </div>
      </div>

      <div class="row">
        <div class="col-6 input-div selectsprocesses">
          <div class="form-group statusdrdown">
            <label
              *ngIf="isTourOn[0] ? true : scenarioConfigForm.get('status')?.value"
              class="sub-header-drpdown"
              >Status</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #status
              [items]="statusList"
              bindLabel="name"
              [searchable]="false"
              formControlName="status"
              [searchFn]="commonInputSearch"
              (change)="saveStatus($event)"
              placeholder="Status"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="status.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 input-div">
          <div class="form-group">
            <span class="d-flex">
              <p class="description-config">
                Description should be only {{ MAX_DESCRIPTION_LENGTH }} characters.
              </p>
              <span
                placement="auto"
                tooltipClass="sku-tooltip"
                class="icon-height"
                ngbTooltip="Describe the scenario and what differentiates it from the other scenarios."
              >
                <a class="info-icon">
                  <span>
                    <img src="./assets/icons/grey-question-icon.svg" width="14" height="14" />
                  </span>
                </a>
              </span>
            </span>

            <div class="services-form scenario-configuration-textarea">
              <textarea
                formControlName="description"
                (change)="onBlur($event)"
                (input)="onInput($event)"
                cols="20"
                id="Description"
                name="Description"
                rows="2"
                class="descriptionHEight"
                maxlength="600"
              ></textarea>
            </div>

            <div class="input-error" *ngIf="isDescriptionExceeded">
              The length of the description has exceeded the limit of {{ MAX_DESCRIPTION_LENGTH }}
              characters.
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 input-div">
          <div class="form-group">
            <span class="d-flex">
              <p class="description-config">
                Report description should be only {{ MAX_REPORT_DESCRIPTION_LENGTH }} characters.
              </p>
              <span
                placement="auto"
                tooltipClass="sku-tooltip"
                class="icon-height"
                ngbTooltip="Describe what will be shown in the PDF report for this scenario."
              >
                <a class="info-icon">
                  <span>
                    <img src="./assets/icons/grey-question-icon.svg" width="14" height="14" />
                  </span>
                </a>
              </span>
            </span>

            <div class="services-form scenario-configuration-textarea">
              <textarea
                formControlName="reportDescription"
                (change)="onBlur($event)"
                (input)="onInput($event)"
                cols="20"
                id="ReportDescription"
                name="ReportDescription"
                rows="2"
                class="descriptionHEight"
                maxlength="1200"
                required
              ></textarea>
            </div>
            <div class="input-error" *ngIf="isReportDescriptionExceeded">
              The length of the report description has exceeded the limit of
              {{ MAX_REPORT_DESCRIPTION_LENGTH }}
              characters.
            </div>
          </div>
        </div>
      </div>
    </form>

    <app-feature-lock
      [isDisabled]="isScenarioFeatureDisabled"
      [featureCode]="FeatureCodes.SCENARIO_SCENARIO_INTERNAL_DATA"
    >
      <div class="row" [piqetAngularSectionAccess]="FeatureCodes.SCENARIO_SCENARIO_INTERNAL_DATA">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <label
              class="subTitleName"
              [joyrideStep]="'step15'"
              [stepPosition]="'right'"
              (prev)="onPrev('step15')"
              (next)="onNextStep('step15')"
              [text]="guideTourStep15Str"
              id="internal-sect"
            >
              Select scenario internal data
              <span
                class="position-relative"
                placement="auto"
                tooltipClass="sku-tooltip"
                ngbTooltip="This feature is not mandatory but may be used for the organizational packaging footprint report."
              >
                <a>
                  <span>
                    <img src="./assets/icons/question-mark-icon.svg" width="14" height="14" /></span
                ></a>
              </span>
            </label>
            <div *ngIf="showEdit">
              <a class="add-link" target="_blank" routerLink="/organization-report/upload-sku"
                ><span class="redirectLinkText">Add internal data</span></a
              >
              <a
                class="setLinkIconPosition"
                target="_blank"
                replaceUrl="true"
                routerLink="/organization-report/upload-sku"
              >
                <img src="./assets/icons/redirect-icon.svg" alt="" width="15" height="13" />
              </a>
              <span class="setLinkIconPosition" (click)="refreshSKU()"
                ><img src="./assets/icons/refresh-circle.svg" alt="" width="14" height="13"
              /></span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row checkboxDivs"
        [piqetAngularSectionAccess]="FeatureCodes.SCENARIO_SCENARIO_INTERNAL_DATA"
      >
        <div class="col-sm-6">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex checkBoxAlienMent">
              <div>
                <input
                  type="checkbox"
                  [checked]="isProjectDefaultSelected"
                  (change)="updateScenarioInternalDataConfiguration(true)"
                  class="chkOverview"
                />
              </div>
              <div><span class="checkbox-text">Use project default</span></div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="d-flex w-100 justify-content-between align-items-center">
            <div class="d-flex checkBoxAlienMent">
              <div>
                <input
                  type="checkbox"
                  [checked]="!isProjectDefaultSelected"
                  (change)="updateScenarioInternalDataConfiguration(true)"
                  class="chkOverview"
                />
              </div>
              <div>
                <span class="checkbox-text header-text-crown-icon"
                  >Scenario specific categorization
                  <app-crown-icon *ngIf="isScenarioFeatureDisabled"></app-crown-icon
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <form [formGroup]="scenarioConfigCheckboxes">
        <div
          class="row d-flex departmentCategory"
          *ngIf="!isProjectDefaultSelected"
          [piqetAngularSectionAccess]="FeatureCodes.SCENARIO_SCENARIO_INTERNAL_DATA"
        >
          <div class="col-4 input-div selectsprocesses">
            <label
              *ngIf="
                scenarioConfigCheckboxes.get('prodDept')?.value ||
                scenarioConfigCheckboxes.get('prodFamily')?.value ||
                scenarioConfigCheckboxes?.get('prodClass')?.value
              "
              class="sub-header-drpdown pb-2"
              >Department</label
            >
            <ng-select
              id="shortDrp"
              [clearable]="true"
              [clearOnBackspace]="false"
              #dept
              [items]="productDepartmentItems"
              (change)="onChangeForDropdown($event, 'department')"
              formControlName="prodDept"
              class="my-1"
              [searchable]="false"
              bindLabel="name"
              placeholder="Department"
              (clear)="setDefaultData('department', true)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="dept.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-4 input-div selectsprocesses">
            <label
              *ngIf="
                scenarioConfigCheckboxes.get('prodDept')?.value ||
                scenarioConfigCheckboxes.get('prodFamily')?.value ||
                scenarioConfigCheckboxes?.get('prodClass')?.value
              "
              class="sub-header-drpdown pb-2"
              >Category</label
            >
            <ng-select
              id="shortDrp"
              [clearable]="true"
              [clearOnBackspace]="false"
              #category
              [items]="productFamilyItems"
              formControlName="prodFamily"
              class="my-1"
              [searchable]="false"
              bindLabel="name"
              (change)="onChangeForDropdown($event, 'category')"
              placeholder="Category"
              (clear)="setDefaultData('category', true)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="category.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-4 input-div selectsprocesses">
            <label
              *ngIf="
                scenarioConfigCheckboxes.get('prodDept')?.value ||
                scenarioConfigCheckboxes.get('prodFamily')?.value ||
                scenarioConfigCheckboxes?.get('prodClass')?.value
              "
              class="sub-header-drpdown pb-2"
              >Sub-category</label
            >
            <ng-select
              id="shortDrp"
              [clearable]="true"
              [clearOnBackspace]="false"
              #subCategory
              [items]="productClassItems"
              (change)="onChangeForDropdown($event, 'subCategory')"
              formControlName="prodClass"
              class="my-1"
              [searchable]="false"
              bindLabel="name"
              placeholder="Sub-category"
              (clear)="setDefaultData('subCategory', true)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="subCategory.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </form>
    </app-feature-lock>

    <hr class="my-4" />

    <div class="row">
      <div class="col-12">
        <label
          class="subTitleName"
          joyrideStep="step16"
          stepPosition="right"
          id="pack-config"
          text="Update packaging level quantities and account for any pallet reuse under 'actions' in the table below."
          (next)="onNextStep('step16')"
          >Packaging configuration</label
        >
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <div class="project-spacing currency-drpdown">
            <ng-select
              [clearOnBackspace]="false"
              [clearable]="false"
              #package
              [items]="packagingList"
              [searchable]="false"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="selectedPackaging"
              [searchFn]="commonInputSearch"
              [multiple]="true"
              placeholder="Packaging list "
              (change)="addUpdatePackagingLevels($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="package.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div
                  [ngOptionHighlight]="search"
                  title="{{ item?.name }}"
                  disabled="item?.selected"
                >
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row pb-5">
      <div class="col-12">
        <div class="packaging-configuration-grid">
          <piqet-angular-portlet
            [columnDefs]="columnDefs"
            [GridRenderForPackageConfiguration]="true"
            [gridName]="'Packaging configuration'"
            [gridData]="packagingLevelInfoList"
            [class]="'overflowCheck'"
            [frameworkComponents]="frameworkComponents"
            [hidePagination]="true"
            [class]="'detail-cell-renderer'"
            [hideSearch]="true"
          ></piqet-angular-portlet>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal-footer justify-content-start"
  [ngClass]="{ 'disabled-project': isScreenDisabled }"
>
  <button
    type="button"
    [disabled]="!scenarioConfigData?.palletConfigurationUpdated"
    class="btn next-btn modelBtn mt-3"
    (click)="change()"
  >
    Next <i class="bi bi-arrow-right checkbox-div"></i>
  </button>
</div>
